import { arrayMove } from '@dnd-kit/sortable';

export interface SameDayReorderPlacement {
  previousTaskId: string | null;
  nextTaskId: string | null;
}

export const getSameDayReorderPlacement = (
  taskIds: string[],
  activeTaskId: string,
  overTaskId: string
): SameDayReorderPlacement | null => {
  const activeIndex = taskIds.indexOf(activeTaskId);
  const overIndex = taskIds.indexOf(overTaskId);

  if (activeIndex === -1 || overIndex === -1 || activeIndex === overIndex) {
    return null;
  }

  const reorderedTaskIds = arrayMove(taskIds, activeIndex, overIndex);
  const newIndex = reorderedTaskIds.indexOf(activeTaskId);

  return {
    previousTaskId: newIndex > 0 ? reorderedTaskIds[newIndex - 1] : null,
    nextTaskId: newIndex < reorderedTaskIds.length - 1 ? reorderedTaskIds[newIndex + 1] : null,
  };
};
